import { createContext, useContext } from 'react';

export type AsyncCleanupFn = () => Promise<boolean | void> | boolean | void;

const ActiveModalContext = createContext({
    modalId: '',
    registerCleanup: async (modalId: string, cleanupFunction: AsyncCleanupFn | undefined) => {}
});

export const useActiveModal = () => {
    return useContext(ActiveModalContext);
};

export default ActiveModalContext;
